import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';
import { CustomizedDialogProps } from './CustomizedDialog';

const useStyles = makeStyles<
  Theme,
  Pick<
    CustomizedDialogProps,
    'maxWidth' | 'color' | 'gutter' | 'fullWidth' | 'borderRadius'
  >
>((theme) => {
  return {
    root: {
      maxWidth: (props) => (props.maxWidth ? props.maxWidth : 476),
      borderRadius: ({ borderRadius }) => (borderRadius ? borderRadius : 16)
    },
    titleRoot: {
      padding: ({ gutter }) =>
        gutter ? `${gutter}px ${gutter}px 0px` : '32px 32px 0px',
      [theme.breakpoints.down('xs')]: {
        padding: ({ gutter }) =>
          gutter ? `${gutter}px ${gutter}px 0px` : '24px 24px 0px'
      }
    },
    iconRoot: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 42,
      height: 42,
      borderRadius: 8,
      backgroundColor: (props) => {
        if (props.color === 'primary') {
          return colorSet.primary200;
        }

        if (props.color === 'error') {
          return colorSet.errorLight;
        }

        if (props.color === 'success') {
          return '#E8F5E9';
        }

        return colorSet.primary200;
      },
      '& > svg': {
        color: (props) => {
          if (props.color === 'primary') {
            return colorSet.primary500;
          }

          if (props.color === 'error') {
            return colorSet.errorMain;
          }

          if (props.color === 'success') {
            return colorSet.successMain;
          }

          return colorSet.primary500;
        },
        width: 24,
        height: 24
      },
      [theme.breakpoints.down('xs')]: {
        width: 32,
        height: 32,
        '& > svg': {
          width: 18,
          height: 18
        }
      }
    },
    title: {
      ...theme.typography.h3,
      fontWeight: 700,
      marginLeft: 18,
      [theme.breakpoints.down('xs')]: {
        ...theme.typography.body1,
        fontWeight: 700,
        marginLeft: 11
      }
    },
    dynamicContentRoot: {
      '&.MuiDialogContent-root': {
        padding: 0
      },
      margin: '32px 0px 0px',
      '&>:first-child': {
        paddingRight: (props) => (props.gutter ? props.gutter : 32),
        paddingLeft: (props) => (props.gutter ? props.gutter : 32),
        paddingBottom: (props) => (props.gutter ? props.gutter : 32),
        [theme.breakpoints.down('xs')]: {
          paddingRight: (props) => (props.gutter ? props.gutter : 24),
          paddingLeft: (props) => (props.gutter ? props.gutter : 24),
          paddingBottom: (props) => (props.gutter ? props.gutter : 24)
        }
      },
      '&>:last-child': {
        paddingRight: '32px',
        paddingLeft: '32px',
        [theme.breakpoints.down('xs')]: {
          paddingRight: '24px',
          paddingLeft: '24px'
        }
      },
      [theme.breakpoints.down('md')]: {
        margin: '24px 0px 0px'
      }
    },
    paperFullWidth: {
      width: '100%'
    },
    paper: {
      margin: (props) => (props.fullWidth ? 0 : 16),
      boxShadow: `0px 24px 24px -6px rgba(0, 0, 0, 0.2), 0px 24px 56px 4px rgba(0, 0, 0, 0.14), 0px 14px 56px 7px rgba(0, 0, 0, 0.12)`
    },
    closeButton: {
      position: 'absolute',
      right: 24,
      top: 24,
      [theme.breakpoints.down('xs')]: {
        right: 16,
        top: 16
      },
      '& svg': {
        color: colorSet.gray900,
        width: 24,
        height: 24,
        [theme.breakpoints.down('xs')]: {
          width: 20,
          height: 20
        }
      }
    },
    actionButton: {
      padding: '32px 24px',
      width: '100%',
      bottom: 32,
      borderRadius: `0px 0px 16px 16px`
    },
    actions: {
      flexDirection: 'column',
      padding: '16px 24px',
      gap: '16px',
      width: '100%',
      borderTop: `1px solid ${colorSet.gray400}`,
      '&:has(.noBorder)': {
        borderTop: 0
      }
    }
  };
});
export default useStyles;
